import jwt_decode from "jwt-decode";
const accessToken =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImFkbWluIiwiYWRtaW4iOnRydWUsImp0aSI6ImQ2MTEwYzAxLWMwYjUtNDUzNy1iNDZhLTI0NTk5Mjc2YjY1NiIsImlhdCI6MTU5MjU2MDk2MCwiZXhwIjoxNTkyNTY0NjE5fQ.QgFSQtFaK_Ktauadttq1Is7f9w0SUtKcL8xCmkAvGLw"
export default accessToken

export function has_Permission(user, module, type){
      if(user?.is_superuser){
        return true
      }else{
        let has_permission = false
        if (user?.group){
          let user_role = user.group.role
          for (let i=0 ; i<user_role.length; i++){
            if(parseInt(user_role[i].module) === parseInt(module)){
              has_permission =  user_role[i][type]
              break
            }
          }

        }
        
        return has_permission

      }
        

}


export function validateToken(accessToken){
  
  var isExpired = false;
  if (accessToken){
    let token = jwt_decode(accessToken);
    let currentDate = new Date();

    // JWT exp is in seconds
    if (token.exp * 1000 < currentDate.getTime()) {
      isExpired = false;
    } else { 
      isExpired = true;
    }
  }
  
  return isExpired

}
